function UserCtrl($auth, $state, $location, UserService, $rootScope, $stateParams, ActionCableConfig, ActionCableChannel, AppSettings, toaster, $scope, ProfileService) {
  'ngInject';
  // ViewModel

  const vm = this;
  vm.loadMoreOrganizations = {
    page: 1,
    loading: false,
    perPage: 10
   }
    // username
  vm.currentYear = new Date().getFullYear();
  vm.init = function () {
    ProfileService.getProfile(function(response) {
      vm.currentUser = response.data;
      $rootScope.unseen_notification_count = $auth.user.unseen_notification_count;
    });

  };

  /**
   * ActionCable Configuration
   * @type {string}
   */

  var auth_header = $auth.retrieveData('auth_headers');
  var wsUrl = AppSettings.wsUrl;
  if(auth_header)
  {
    ActionCableConfig.wsUri= wsUrl + '?access-token=' + auth_header['access-token'] + '&client='+ auth_header['client'] + '&uid=' + auth_header['uid'];
  }else{
    ActionCableConfig.wsUri= wsUrl;
  }
  ActionCableConfig.debug = true;
  ActionCableConfig.autoStart= false;


  (new ActionCableChannel('NotificationChannel')).subscribe(function(data){
    if(data.data && data.data.product_cost && $state.current.name == 'user.organization.settingView.productListing')
    {
      $rootScope.$emit('UpdateProductCostFromNotification', data.data.product_cost);
    }

    if(data.data && data.data.amazon_journal && $state.current.name == 'user.organization.dashboard.amazon.newJournal')
    {
      $rootScope.$emit('UpdateAmazonJournalFromNotification', data.data.amazon_journal);
    }

    if(data.data && data.data.shopify_invoice && $state.current.name == 'user.organization.dashboard.shopify.newInvoice')
    {
      $rootScope.$emit('UpdateShopifyInvoiceFromNotification', data.data.shopify_invoice);
    }

    if(data.data && data.data.bulk_cost_journal && $state.current.name == 'user.organization.dashboard.bulk')
    {
      $rootScope.$emit('UpdateBulkCostJournalFromNotification', data.data.bulk_cost_journal);
    }

    if(data.data && data.data == 'retreive_organization') {
      $rootScope.$emit('UpdateConnectionFromNotification', data.data.retreive_organization);
    }

    if(data.notification.id){
      $rootScope.unseen_notification_count = $rootScope.unseen_notification_count + 1;
      if($state.current.name == 'user.notification'){
       $rootScope.$emit('UpdateNotification', data.notification);
      }
    }
    toaster.pop(data.notification.notification_type, data.notification.body);
  });

  vm.user = $auth.user;
  vm.changeOrganization = function(){
    $rootScope.currentOrg = $rootScope.currentOrgObj.id;
   return $state.go($state.current.name, {orgId: $rootScope.currentOrg}, {inherit: false});
  };


  $rootScope.$on('user_updated',function(event,data){
    vm.updateUser(data);
  })

  vm.updateUser = function(data){
    vm.currentUser  = data;
  }
  vm.handleSignOutBtnClick = function () {
    $auth.signOut()
      .then(function(resp) {
        $state.go('login');
      })
      .catch(function(resp) {
        alert('Error occurred...');
        // handle error response
      });
  }

  vm.isActiveTab = function(name, name1){
    return  $state.current.name.startsWith(name) || $state.current.name.startsWith(name1);
  }

  vm.isLeftMenuActive = function(name,name1,name2){
    return  $state.current.name.startsWith(name) || $state.current.name.startsWith(name1) || $state.current.name.startsWith(name2);
  }

  vm.currentPath = $location.path();

  vm.isAmazon = function(){
    return $state.current.name == 'user.organization.dashboard.amazon.amazon-cogs';
  };

  vm.isShopify = function(){
      return $state.current.name == 'user.organization.dashboard.shopify.invoice';
  };

  vm.isReports = function(){
      return $state.current.name == 'user.organization.dashboard.reports.list';
  };

  vm.isAmazonPayout = function(){
    return $state.current.name == 'user.organization.dashboard.amazonPayout.invoices';
  };

  vm.refreshOrganizationList = function(search){
    vm.loadMoreOrganizations = {
      page: 1,
      perPage: 10
     };
    let url = `/organizations.json?by_organization_name=${search}&default_id=${$rootScope.orgId}&sort=name`;
    UserService.listOrganizations(url,function(response){
      if(response && response.data && (response.data.organizations || response.data.default_organization )) {
       $rootScope.userOrganizations = UserService.getOrganizationArray(response.data);
      }
    });
  };

  vm.loadMoreOrganizationList = function(search){
    if(!vm.loadMoreOrganizations.loading && ($rootScope.userOrganizations.length / vm.loadMoreOrganizations.perPage) >=  vm.loadMoreOrganizations.page ){
    vm.loadMoreOrganizations.loading = true;
    let url = `/organizations.json?by_organization_name=${search}&sort=name&page=${vm.loadMoreOrganizations.page + 1}&size=${vm.loadMoreOrganizations.perPage}`;
    UserService.listOrganizations(url,function(response){
      vm.loadMoreOrganizations.loading = false;
      if(response && response.data && response.data.organizations) {
       $rootScope.userOrganizations =  $rootScope.userOrganizations.concat(UserService.getOrganizationArray(response.data));
       vm.loadMoreOrganizations.page = vm.loadMoreOrganizations.page + 1;
      }
    });
  }

  }

  vm.startPendingJobs = function(orgId,type){
    if( !vm.pendingJobs) {
      vm.pendingJobs = true;
      UserService.startPendingJobs(orgId, type, function (response) {
        vm.pendingJobs = false;
        if (response.status == 200 && response.data && response.data.message) {
          toaster.pop('info', response.data.message);
        } else {
          toaster.pop('error', ConnectionService.throwError(response));
        }
      });
    }
  }

  // vm.showAmazonPendingJob =function(orgId){
  //   debugger
  //   UserService.showAmazonPendingJob(orgId, function (response){
  //     if(response.data.count > 0){
  //       return 'disable';
  //     }
  //      return '';
  //   });
  // }
  $rootScope.getDate = function(rawDate)
  {
    return new Date(rawDate)
  }
}

export default {
  name: 'UserCtrl',
  fn: UserCtrl
};
